import { css } from 'twin.macro';
import { Button } from 'react-bootstrap';
import { FaArrowLeft, FaArrowRight } from 'react-icons/fa';
import { scrollToTopOnNavigation } from './utils';
import { formPaginationContainerStyles } from './styles';

const FormPagination = ({ pages = [], currentPage = 0, setCurrentPage, setValidationError, updateSeenFields }) => {
    const handleNavigation = ({ mode }) => {
        // Validate current page before proceeding use some prop in the form builder
        if (mode === 'previous') {
            setCurrentPage((prev) => {
                if (prev > 0) {
                    const newPage = prev - 1;
                    updateSeenFields(newPage);
                    return newPage;
                }
                return prev;
            });
            setValidationError(null);
        } else if (mode === 'next') {
            setCurrentPage((prev) => {
                const newPage = prev + 1;
                updateSeenFields(newPage);
                return newPage;
            });
        }
        scrollToTopOnNavigation();
    };
    return (
        <div css={formPaginationContainerStyles}>
            <div>
                {currentPage > 0 && (
                    <Button
                        variant="secondary"
                        onClick={() => {
                            handleNavigation({ mode: 'previous' });
                        }}
                        css={css`
                            margin-right: 1rem;
                        `}
                    >
                        <FaArrowLeft className="mr-2" />
                        Previous
                    </Button>
                )}
            </div>

            <div
                css={css`
                    color: #666;
                    font-weight: bold;
                `}
            >
                Page {currentPage + 1} of {pages.length}
            </div>

            <div>
                {currentPage < pages.length - 1 ? (
                    <Button
                        variant="secondary"
                        onClick={async () => {
                            handleNavigation({ mode: 'next' });
                        }}
                    >
                        Next
                        <FaArrowRight className="ml-2" />
                    </Button>
                ) : null}
            </div>
        </div>
    );
};

export default FormPagination;
